export default __webpack_public_path__ + "static/media/silversea16x9.07723993.jpg";